"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const WebRtcConnection_1 = require("./WebRtcConnection");
class WebRtcConnectionsPool {
    constructor(useFraming = false, channelName = 'some-channel') {
        this.pool = [];
        this.onOpenCallbacks = [];
        this.onMessageCallbacks = [];
        this.onCloseCallbacks = [];
        this.useFraming = false;
        this.channelName = 'some-channel';
        this.useFraming = useFraming;
        this.channelName = channelName;
    }
    connect(signaling, iceServers = []) {
        const connection = new WebRtcConnection_1.WebRtcConnection(signaling, iceServers, this.useFraming, this.channelName);
        connection.addOnOpenCallback(() => {
            this.onOpen();
        });
        connection.addOnMessageCallback((message, peerId) => {
            this.onMessage(message, peerId);
        });
        connection.addOnCloseCallback(() => {
            this.onClose();
        });
        this.pool.push(connection);
        return connection;
    }
    addOnOpenCallback(callback) {
        this.onOpenCallbacks.push(callback);
    }
    addOnMessageCallback(callback) {
        this.onMessageCallbacks.push(callback);
    }
    addOnCloseCallback(callback) {
        this.onCloseCallbacks.push(callback);
    }
    sendMessage(message) {
        for (const connection of this.pool) {
            connection.sendMessage(message);
        }
    }
    close() {
        for (const connection of this.pool) {
            connection.close();
        }
    }
    closeConnection(connection) {
        const index = this.pool.indexOf(connection, 0);
        if (index > -1) {
            this.pool.splice(index, 1);
        }
        connection.close();
    }
    onOpen() {
        for (const callback of this.onOpenCallbacks) {
            callback();
        }
    }
    onMessage(message, peerId) {
        for (const callback of this.onMessageCallbacks) {
            callback(message, peerId);
        }
    }
    onClose() {
        for (const callback of this.onCloseCallbacks) {
            callback();
        }
    }
}
exports.WebRtcConnectionsPool = WebRtcConnectionsPool;
